import { HorizontalRule } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import arrow_up_icon from '../../../assets/images/arrow_up_icon.svg';
import arrow_down_icon from '../../../assets/images/arrow_down_icon.svg';

export const BetPriceDirection = (props) => {
	const { direction, selected, isLoading } = props;
	
	if (isLoading) {
		return (
			<div style={{ backgroundColor: selected ? '#363844' : '' }} className="ml-0.5">
				<Tooltip title="Loading price history...">
					<div 
						style={{ 
							width: '10px',
							height: '10px',
							borderRadius: '50%',
							backgroundColor: '#7a8299',
							opacity: 0.2
						}} 
					/>
				</Tooltip>
			</div>
		);
	}
	
	return (
		<div style={{ backgroundColor: selected ? '#363844' : '' }}>
			{direction === 0 && (
				<div style={{ backgroundColor: selected ? '#363844' : '' }} className="ml-0.5">
					<Tooltip title="price hasn't moved recently">
						<HorizontalRule sx={{ color: '#fff' }} style={{ backgroundColor: selected ? '#363844' : '' }} />
					</Tooltip>
				</div>
			)}
			{direction === 1 && (
				<div style={{ backgroundColor: selected ? '#363844' : '' }} className="ml-0.5">
					<Tooltip title="price trending upwards">
						<img src={arrow_up_icon} alt="arrow up icon" />
					</Tooltip>
				</div>
			)}
			{direction === -1 && (
				<div style={{ backgroundColor: selected ? '#363844' : '' }} className="ml-0.5">
					<Tooltip title="price trending downwards">
						<img src={arrow_down_icon} alt="arrow down icon" />
					</Tooltip>
				</div>
			)}
		</div>
	);
};
